import type { UiNode, UiNodeInputAttributes } from '@ory/client';
import ActionButton from '@/components/Button/ActionButton';
import ResponseMessage from '@/components/Error/ResponseMessage';
import { Spacer, VStack } from '@/components/Layout';
import { useNodeTranslation } from '@/features/auth/hooks/useNodeTranslation';

/** 表示順序: 再送ボタンは一番最後に配置 */
export const ORDER = 100;
type Props = {
  node: UiNode;
  disabled?: boolean;
};

/**
 * 再送ボタンとして扱うname属性のリスト
 *
 * - resend: 一般的な再送ボタン
 * - resend_code: コード再送ボタン
 * - email: Ory Kratosのリカバリーフローで使用されるコード再送ボタン
 */
const RESEND_NAMES = ['resend', 'resend_code', 'email'] as const;

/**
 * Resend inputノードコンポーネント
 *
 * Ory KratosのServer Driven UIで返されるresend inputフィールドをレンダリングします。
 * 再送信をトリガーするために使用されます。
 * 既存のActionButtonコンポーネントを使用して、デザインシステムに準拠したボタンを表示します。
 */
export function ResendInput({
  node,
  disabled
}: Props) {
  const {
    translateUiText
  } = useNodeTranslation();
  const attrs = node.attributes as UiNodeInputAttributes;

  // resend inputの場合はtype="submit"かつRESEND_NAMESのいずれかである必要がある
  const isResendButton = attrs.type === 'submit' && RESEND_NAMES.includes(attrs.name as (typeof RESEND_NAMES)[number]);
  if (!isResendButton) {
    return null;
  }
  const label = node.meta?.label ? translateUiText(node.meta.label) : undefined;
  const errorMessages = node.messages?.filter(msg => msg.type === 'error').map(msg => translateUiText(msg));
  return <VStack className="w-full mt-4 gap-0">
      <ActionButton type="submit" name={attrs.name} value={attrs.value as string} disabled={disabled ?? attrs.disabled} variant="outline" className="w-full">
        {label}
      </ActionButton>
      {errorMessages && errorMessages.length > 0 && <>
          <Spacer variant="xxs" />
          <ResponseMessage type="error" size="xs">
            {errorMessages[0]}
          </ResponseMessage>
        </>}
    </VStack>;
}